export default __webpack_public_path__ + "media/flags/ga-86c28bc8.svg";